import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {CombineRgbSockets} from "#material/nodes/converter/combine-rgb/definition"
import {combineRgbDefinition} from "#material/nodes/converter/combine-rgb/definition"
import type {CyclesReturns} from "#material/sockets/cycles"
import {threeValue} from "#material/three/three-utils"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {registerMaterialGraphNode} from "#material/register"
import {ThreeTsl as TSL} from "#material/three/exports"
import type {ThreeReturns} from "#material/sockets/three"
import type {CombineRgbNode} from "#material/cycles/types"

@registerMaterialGraphNode
export class CombineRgb extends MaterialNode<CombineRgbSockets> {
    public override get definition() {
        return combineRgbDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<CombineRgbSockets>> => {
        const {r, g, b} = await evaluator.getAll({
            r: this.parameters.inputs.r,
            g: this.parameters.inputs.g,
            b: this.parameters.inputs.b,
        })
        const rValue = r?.toFloat() ?? threeValue(this.parameters.settings.r ?? 0)
        const gValue = g?.toFloat() ?? threeValue(this.parameters.settings.g ?? 0)
        const bValue = b?.toFloat() ?? threeValue(this.parameters.settings.b ?? 0)

        return {image: TSL.vec3(rValue, gValue, bValue).toColor()}
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<CombineRgbSockets>> => {
        const combinRgb: CombineRgbNode = {
            type: "combine_rgb",
            inputs: await evaluator.getAll({
                r: this.parameters.inputs.r,
                g: this.parameters.inputs.g,
                b: this.parameters.inputs.b,
            }),
            parameters: {
                r: this.parameters.inputs.r ? undefined : this.parameters.settings.r,
                g: this.parameters.inputs.g ? undefined : this.parameters.settings.g,
                b: this.parameters.inputs.b ? undefined : this.parameters.settings.b,
            },
            resources: {},
        }

        return {image: [combinRgb, "image"]}
    }
}
